<form [formGroup]="form">
  <div hlmFieldGroup>
    <div hlmField>
      <label hlmFieldLabel for="select-region">Région</label>
      <hlm-select id="select-region" formControlName="region">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (region of regions() | trierPar: 'nom'; track region.id) {
            <hlm-option [value]="region.id">
              {{ region.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
    <div hlmField>
      <label hlmFieldLabel for="select-site">Site</label>
      <hlm-select id="select-site" formControlName="site">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (site of sites() | trierPar: 'nom'; track site.id) {
            <hlm-option [value]="site.id">
              {{ site.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
    <div hlmField>
      <label hlmFieldLabel for="select-metier">Métier</label>
      <hlm-select id="select-metier" formControlName="metier">
        <hlm-select-trigger>
          <hlm-select-value />
        </hlm-select-trigger>

        <hlm-select-content>
          @for (referentiel of referentiels() | trierPar: 'nom'; track referentiel.id) {
            <hlm-option [value]="referentiel.id">
              {{ referentiel.nom }}
            </hlm-option>
          }
        </hlm-select-content>
      </hlm-select>
    </div>
  </div>

  <button
    class="text-components-content-neutral-secondary component-small-medium ml-xs mt-sm pl-0 underline"
    hlmBtn
    variant="link"
    type="reset"
  >
    Réinitialiser les filtres
  </button>
</form>
